import { createSelector } from 'reselect';

// Selector to get the duration of a Blob video
export const getBlobDuration = createSelector(
    [(state) => state?.blob],
    (blob) => new Promise((resolve, reject) => { // Return a promise to asynchronously resolve the duration of the Blob video
        // Create a video element to load the Blob and get its duration
        const videoElement = document.createElement('video');
        videoElement.src = URL.createObjectURL(blob);
        // Event listener for when metadata is loaded
        videoElement.addEventListener('loadedmetadata', () => {
            // Workaround for Chrome bug where duration of Blob videos might be Infinity
            // Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=642012
            if (videoElement.duration === Infinity) {
                // Set currentTime to a large value to trigger timeupdate event
                videoElement.currentTime = Number.MAX_SAFE_INTEGER;
                // Once timeupdate event fires, resolve with duration and reset currentTime
                videoElement.ontimeupdate = () => {
                    videoElement.ontimeupdate = null;
                    resolve(videoElement.duration);
                    videoElement.currentTime = 0;
                };
            } else {
                // If duration is not Infinity, resolve with duration immediately
                resolve(videoElement.duration);
            }
        });
        // Event listener for errors during video loading
        videoElement.addEventListener('error', (error) => {
            reject(error);
        });
        // Load the video
        videoElement.load();
    }),
);
